export class Page {
	title;
	slug;
	url;
	subPages; // object or array of Pages;

	constructor(title, slug, url, subPages) {
		// Initialization of the proprieties.
		this.title = title;
		this.slug = slug;
		this.url = url;
		this.subPages = subPages ? this.createSubPages(subPages) : null;
	}

	// Returns object or array of Page's
	createSubPages(subPages) {

		if (typeof subPages !== "object") return null;

		let content;
		if (Array.isArray(subPages))
		{

			content = subPages.map(subPage => {
				// console.log("name should be", subPage.title);
				return new Page(subPage.title.rendered || subPage.title, subPage.slug, `${this.url}/${subPage.slug}`);
			});
		} else {
			const keys = Object.keys(subPages);

			content = {};

			for (let i = 0; i < keys.length; i++)
			{
				Object.assign(content, {
					[keys[i]]: new Page(subPages[keys[i]].title, this.slug, this.url, this.createSubPages(subPages[keys[i]].data))
				});
			}
		}

		return content;
	}
}



// WEBPACK FOOTER //
// ./src/data/classes/page.class.js